import { removeUndefinedFieldsFromObject } from '@vfde-brix/ws10/core';
import {
    Notification,
    createNotification,
    INotificationProperties,
} from '@vfde-brix/ws10/notification';
import { COLOR_WHITE } from '@vfde-brix/ws10/styles';
import { INotificationOptionalProps } from 'app/container/Authentication/interfaces/main.interface';

/**
 * mountNotification
 */
export const mountNotification = (wrapperId: string, optionalProps?: INotificationOptionalProps): Notification | null => {
    const { optState, stdHeadline, txtContent, containerButtons } = optionalProps || {};
    const wrapperElement = document.getElementById(wrapperId);
    const notificationProps = <INotificationProperties>removeUndefinedFieldsFromObject({
        optState,
        stdHeadline,
        txtContent,
        optBackground: COLOR_WHITE,
        containerButtons,
        business: {},
    });

    return wrapperElement && createNotification(wrapperElement, notificationProps);
};
